module.exports = __webpack_public_path__ + "img/safetyplus.2ec2b22d.svg";